/* eslint-disable */
<template>
  <div id="loading">
    <img src="../assets/img/loading.gif" alt="loading" />
  </div>
</template>

<script>
export default {
  name: "LoadingComponent"
};
</script>

<style lang="css" scoped>
</style>